export const DesignStrings = {
  ufFeedFlowRate: "UF Feed Flow Rate",
  automatic: "Automatic",
  ufTechnologySelection: "UF Technology Selection",
  ufTechnology: "UF Technology",
  designFlowFluxRates: "Design Instantaneous (Gross) Flux and Flow Rates",
  backwashFlush: "Backwash Flux",
  cebFlux: "CEB Flux",
  forwardFlushFlow: "Forward Flush Flow",
  airFlow: "Air Flow",
  aerationAirFlow: "Aeration Air Flow",
  cIPRecycleFlowRate: "CIP Recycle Flow Rate",
  miniCIPRecycleFlowRate: "mini-CIP Recycle Flow Rate",
  forwardFlush: "Forward Flush",
  uFSpecialFeatures: "UF Special Features",
  adjustpHAddOxidantCoagulant: "Adjust pH, Oxidant/Coagulant",
  cEBOnly: "CEB only",
  miniCIPOnly: "mini-CIP only",
  CEBAndMiniCIP: "CEB and mini-CIP",
  designCycleInterval: "Design Cycle Intervals",
  filtrationDuration: "Filtration Duration",
  miniCip: "mini-CIP",
  acidCEB: "Acid CEB",
  disinfectionCEB: "Disinfection CEB",
  membraneIntegrityTesting: "Membrane Integrity Testing",
  offlineTimeperUnit: "Offline Time per Unit",
  airScour: "Air Scour",
  drain: "Drain",
  bWRinseDrainBottom: "BW Rinse Drain Bottom",
  bWRinseDrainTop: "BW Rinse Drain Top",
  cebTemprature: "CEB Temperature",
  digramForFeedWater: "Use design temperature from feed water",
  waterSource: "Water Source",
  cebWaterSource: "CEB Water Source",
  mineralAcid: "Mineral Acid",
  organicAcid: "Organic Acid",
  alkaliOxidantCEB: "Alkali/Oxidant CEB",
  alkali: "Alkali",
  oxidant: "Oxidant",
  duration: "Duration",
  durations: "Durations",
  chemicalSoakingDuration: "Chemical Soaking Duration",
  filtratetoLevel: "Filtrate to Level",
  lumenFill: "Lumen Fill",
  backwashesbetweenAirScour: "Backwashes between Air Scour",
  backwashTemprature: "Backwash Temperature",
  backwashWaterSource: "Backwash Water Source",
  forwardFlushWaterSource: "Forward Flush Water Source",
  backwashProtocol: "Backwash Protocol",
  cIP: "CIP",
  filtrateFlux: "Filtrate Flux",
  cipRecycleFlowRateInfo:
    "The CIP Recycle Flow Rate refers to the amount of fluid entering the system through the CIP Inlet Pipe during the cleaning process. During this step, the flow divides into two parts: one part is  the filtrate and the other part is the concentrate. Both parts are then circulated back to the modules.",
  tocRejection: "TOC Rejection",
  tocRejectionCOD: "COD (as KMnO4) Rejection",
  tocRejectionTitle: "UF Organics Rejection",
  tocRejectionNote:
    "Note: This feature is used to account for organics rejection by UF membranes. A default value is given but users are encouraged to use a relevant figure to their system.",
  designModuleWarning: "Technology change",
  designModuleWarningMessage: valueChange =>
    `This ${valueChange} change will update your parameters with default values. Please review before generating report.`,
};

export const IngeString = {
  topbackwash: "BW Drain Bottom",
  bottomBackwash: "BW Drain Top",
  cebTopBackwash: "CEB Injection Drain Bottom",
  cebBottomBackwash: "CEB Injection Drain Top",
  selectedConfRackLabel: "T-Rack™ Design",
  recommConfigSliderMinRange: "Min T-Rack™ Size Limit: ",
  recommConfigSliderMaxRange: " :Max T-Rack™ Size Limit",
  backwashProtocolVal: "Normal protocol (RCBW)",
  moduleUnitMultiplierWarning: "multiple of ${multiplier}",
};

export const ValidationStrings = {
  slsRecommendedRange: "SLS Recommended Range",
  cipMineralAcidConectration: "CIP Mineral Acid Concentration",
  cipOrganicAcidConcentration: "CIP Organic Acid Concentration",
  cipAlkaliConcentration: "CIP Alkali Concentration",
  cipOxidantConcentration: "CIP Oxidant Concentration",
  cipRecycle: "CIP Recycle",
  cipHeatingStep: "CIP Heating Step",
  cipSoak: "CIP Soak",
};

export const ProjectStrings = {
  leaveProjectTooltip: "Click to leave project",
  requestLockTooltip: "Click to request unlock from ${userName}",
  projectSharedBy: "Project owner:",
  deleteProjectTitle: "Delete project?",
  deleteNote: "For 30 days you can find this in the Deleted directory and restore",
  deleteNotePermanent: "This can't be undone, Do you want to permanently delete this project",
  renameThisProject: "Rename this project",
  projectNameAlreadyExist: "Project name already exists",
  projectLengthValidation: "Project name must contain 3 to 200 characters",
  projectInputFieldValidation: "Project name cannot be blank.",
  editedJustNow: "Edited just now",
  createJustNow: "Created just now",
  projectName: "Project Name",
  addToFavorite: "Add to Favorite",
  removeFromFavorite: "Remove from Favorite",
  duplicateProject: "Duplicate Project",
  addCollaborators: "Collaborators",
  renameProject: "Rename Project",
  exportProject: "Export Project",
  unlockProject: "Unlock Project",
  checkingUnlockStatus: "Checking project accessibility",
  projectLockedByCollaborator: "Project has been locked by ${userName}",
  sendProject: "Send Project",
  deleteProject: "Delete Project",
  restoreProject: "Restore Project",
  permanentlyDelete: "Permanently Delete",
  removeFromFolder: "Remove from Folder",
  projectSentBy: "Sent by ${sendBy}",
  saveProject: "Save project",
  makeAsNewDefault: "Make as new default",
  moreMenuTooltip: "More Menu",
  clickToOpenMenu: "Click to open menu",
  lockedProjectTooltip: "Project is locked by you. Unlock for other collaborators to access",
  sharedProjectTooltip: "No collaborator is editing the project currently",
  examples: "Examples",
  usedTechnology: "is currently used in process map you can not deselect the technology.",
  NA: "N/A",
};

export const projectInfoModalStrings = {
  defaultState: "Select State",
  defaultCountry: "Select Country",
  defaultMarketSegment: "Select Market Segment",
  defaultMarketSegmentFilter: "All",
  fieldsToCheck: [
    "projectName",
    "caseName",
    "marketSegmentID",
    "projectNotes",
    "designer",
    "designerCompany",
    "customer",
    "countryID",
    "stateID",
    "city",
    "lstTechnologyListVMs",
  ],
};

export const CarouselStrings = {
  welcometoWavePro: "Welcome to WAVE PRO",
  workingTogetherForFuture: "Working together for a clean-water future",
};

export const EMPTY_STATE_STRINGS = t => ({
  all_projects: {
    title: t("emptyState.allProjectTitle"),
    description: t("emptyState.allProjectDescription"),
    buttonText: t("emptyState.allProjectbuttonText"),
  },
  favourite_projects: {
    title: t("emptyState.favouriteProjectTitle"),
    description: t("emptyState.favouriteProjectDescription"),
  },
  imported_projects: {
    title: t("emptyState.importedProjectTitle"),
    description: t("emptyState.importedProjectDescription"),
    buttonText: t("emptyState.importedProjectButtonText"),
  },
  deleted_items: {
    title: t("emptyState.deletedItemTitle"),
    description: t("emptyState.deletedItemDescription"),
  },
  collaboration_history: {
    title: t("emptyState.collaborationHistoryTitle"),
    description: t("emptyState.collaborationHistoryDescription"),
  },
  projects_share_by_me: {
    title: t("emptyState.projectSharedByMeTitle"),
    description: t("emptyState.projectSharedByMeDescription"),
  },
  projects_share_with_me: {
    title: t("emptyState.projectSharedWithMeTitle"),
    description: t("emptyState.projectSharedWithMeDescription"),
  },
  folders: {
    title: t("emptyState.foldersTitle"),
    description: t("emptyState.foldersDescription"),
    buttonText: t("emptyState.foldersButtonText"),
  },
  search_items: {
    title: t("emptyState.serachItemTitle"),
    description: t("emptyState.serachItemDescription"),
  },
  search_items_folder: {
    title: t("emptyState.searchItemFolderTitle"),
    description: t("emptyState.searchItemFolderDescription"),
  },
  folderProjectNotFound: {
    title: t("emptyState.folderProjectNotFoundTitle"),
    description: t("emptyState.folderProjectNotFoundDscription"),
  },
  search_deleted_items: {
    title: t("emptyState.searchDeletedItemsTitle"),
    description: t("emptyState.searchDeletedItemsDescription"),
  },
});

export const CurrencyAndUnitsStrings = {
  makeDefaulCurrencyConfirmation: "Are you sure you want to update the default currency settings",
  makeDefaultUnitConfirmation: "Are you sure you want to update default units of measure",
  makeDefaultTechConfirmation: "Are you sure you want to change the default technology preferences",
  dollarCurrency: "US Dollar($)",
  currencyErrorMsg: "The currency exchange rate must be more than 0",
  currencyDefaultMsg: "Its measured against USD($)",
  exchnageRateLabel: "Currency Exchange Rate",
};

export const InputStrings = t => ({
  softRange: t("recommendedRange") + " ${min} – ${max}",
  hardRange: t("ranges") + " ${min} – ${max}",
  outOfRange: t("outOfRange") + " ${min} – ${max}",
  recommended: t("recommended"),
});
